import React from 'react';
import {Box} from '@mui/material';
import {
    AdsClickOutlined,
    AutoAwesomeOutlined,
    CallSplitOutlined,
    CampaignOutlined,
    DesktopWindowsOutlined,
    FlagOutlined,
    HubOutlined
} from '@mui/icons-material';
import {SettingsEmptyState} from '../settings/SettingsDesign';

const views = {
    campaigns: {icon: CampaignOutlined, plural: 'campaigns', singular: 'a campaign'},
    automation: {icon: AutoAwesomeOutlined, plural: 'automation rules', singular: 'an automation rule'},
    affiliateNetworks: {icon: HubOutlined, plural: 'affiliate networks', singular: 'an affiliate network'},
    offers: {icon: FlagOutlined, plural: 'offers', singular: 'an offer'},
    landings: {icon: DesktopWindowsOutlined, plural: 'landings', singular: 'a landing'},
    trafficSources: {icon: AdsClickOutlined, plural: 'traffic sources', singular: 'a traffic source'},
    flows: {icon: CallSplitOutlined, plural: 'flows', singular: 'a flow'}
};

export default function ReportEmptyState({kind, archived = false}) {
    const view = views[kind];
    return <Box
        role="status"
        sx={{
            position: 'absolute', top: 35, bottom: 35, left: 0, right: 0,
            display: 'flex', alignItems: 'center', justifyContent: 'center', pointerEvents: 'none'
        }}>
        <SettingsEmptyState
            icon={view.icon}
            title="No records found"
            description={archived ? `No archived ${view.plural} match your filters.` : `Add ${view.singular} or adjust your filters and date range to find matching records.`}/>
    </Box>;
}
